import { Routes } from '@angular/router';
import { CredentialComponent } from './layout/credential/credential.component';
import { AdminLayoutComponent } from './layout/admin/admin-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { planGuard } from './core/guards/plan.guard';
import { LoginComponent } from './auth/login/login.component';
import { CampaignPageComponent } from './pages/campaign-page/campaign-page.component';
import { ShareCallbackComponent } from './pages/share-callback/share-callback.component';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Iniciar sesión',
    component: LoginComponent
  },
  {
    path: 'share/callback',
    title: 'Compartir',
    component: ShareCallbackComponent
  },
  {
    path: 'share/:slug',
    component: CampaignPageComponent
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    loadChildren: () => import('./layout/admin/admin.routes').then(r => r.routes),
    canActivate: [authGuard, planGuard]
  },
  {
    path: ':clientSlug/:slug',
    component: CredentialComponent,
    data: { skipTitle: true },
    loadChildren: () => import('./layout/credential/credential.routes').then(r => r.routes)
  },

  { path: '**', redirectTo: 'admin/dashboard', pathMatch: 'full' }
];
